// This file is a near-copy of src/common/ean_8_reader.ts of
// @ericblade/quagga2, under the MIT License.

// Copyright (c) 2014 Christoph Oberhofer, (c) 2019 Eric Blade and all other
// contributors

import EANReader, { CODE_G_START, MIDDLE_PATTERN } from "./ean-reader";
import type { BarcodePosition, BarcodeInfo } from "./barcode-reader";
import { CodeScannerStandard } from "common/code-scanner-standards";

class EAN8Reader extends EANReader {
    FORMAT = CodeScannerStandard.EAN_8;
    protected _decodePayload(
        inCode: BarcodePosition,
        result: Array<number>,
        decodedCodes: Array<BarcodePosition>
    ): BarcodeInfo | null {
        let code: BarcodeInfo | BarcodePosition | null = inCode;

        for (let i = 0; i < 4; i++) {
            code = this._decodeCode(code.end, CODE_G_START);
            if (!code) {
                return null;
            }
            result.push((code as BarcodeInfo).code);
            decodedCodes.push(code);
        }

        code = this._findPattern(MIDDLE_PATTERN, code.end, true, false);
        if (code === null) {
            return null;
        }
        decodedCodes.push(code);

        for (let i = 0; i < 4; i++) {
            code = this._decodeCode(code.end, CODE_G_START);
            if (!code) {
                return null;
            }
            decodedCodes.push(code);
            result.push((code as BarcodeInfo).code);
        }

        return code as BarcodeInfo;
    }
}

export default EAN8Reader;
